import title from "../media/images/flowRacksT.png";
import image2 from "../media/images/flowRacks.png";
import "./FlowRacks.css";
const FlowRacks = () => {
    return (  
        <div className="FlowRacks">
        <div className="flowPage">
            <div className="flowTitle">
                <img src={title} alt="d"/>
            </div>
            <div className="flowText" style={{height:"115%"}}>
                 <div className="blockText">
                    <div className="flowBigText">
                        <p >EFFECTIVE AND ERGONOMIC</p>
                        <p >FLOW RACKS</p>     
                    </div>
                    <div className="flowSmall">
                        <p >

                Gravity flow racking uses space efficiently providing high-density storage. The FIFO aspect of gravity flow racking and the natural flow of products makes it easier for workers to access the stock they seek, either by forklift or manual picking for smaller items.<br/>
                GRAVITY CONVEYORS are also known as FiFo "First In First Out" racks, gravity racks, supermarket racks, or SAG racks.<br/>
                They allow industrial containers, KLT crates, or loose parts to flow from back to front thanks to the inclined roller conveyors in which the force of gravity pushes the picking on a FIFO basis.
                With the modular system, you can create custom shelving to meet your specific needs.<br/>
                Fully customizable modular racks protect your components from potential damage, free up valuable floor space, and thus ensure that the operator works in an ergonomic "Golden Zone". Flow rack structures are ideal for a Kanban system.<br/>
                We can provide seven types of flow racks that can increase production line efficiency:<br/>
                Supermarket warehouse<br/>
                Dynamic shelving<br/>
                SAG<br/>
                L-shaped rack for the proximity of parts<br/>
                Adaptable racks per set-up<br/>
                ESD shelving<br/>
                WIP rack to reduce defects<br/>
                Are you in need of a Gravity Flow Racking solution?<br/>

                Ecomode Studio will be able to analyze and identify the specific requirements of your project, helping to design and provide the perfect system for you.<br/>
                        </p>
                    </div>
                </div>
                <div className="flowBlockImage">
                    <img  src={image2} alt=""/>
                </div>
            </div>
                <div className="flowBlockImagePhone">
                    <img  src={image2} alt=""/>
                </div>
            <div className="flowCBlockK">
                <p>©Ecomode Studio 2025 - All Rights reserved</p>
            </div>
        </div>
        </div>
    );
}
 
export default FlowRacks;